import { useEffect } from "react";

/**
 * Default document title, mirroring `index.html`. Restored when a titled page
 * unmounts so SPA navigation back to an untitled route doesn't keep a stale
 * per-page title.
 */
export const DEFAULT_DOCUMENT_TITLE = "DeployCompare · Review Terraform deploy risk";

/**
 * Per-route `document.title` for the public pages (marketing, legal, demo,
 * help). Callers pass the full title including the `· DeployCompare` suffix.
 * The authenticated runtime manages its own richer title in AppRuntime — this
 * hook is the lightweight counterpart for static routes, so every public page
 * gets a distinct title for SEO, history, and tab identification.
 */
export function useDocumentTitle(title: string): void {
  useEffect(() => {
    document.title = title;
    return () => {
      document.title = DEFAULT_DOCUMENT_TITLE;
    };
  }, [title]);
}
